import {Component, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { MainAccionesDialogoCtaComponent } from '../main-acciones-dialogo-cta/main-acciones-dialogo-cta.component';

@Component({
  selector: 'neo-main-cta',
  templateUrl: './main-cta.component.html',
  styleUrls: ['./main-cta.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainCtaComponent implements OnInit {
  @Input() url: string;
  @Input() target = false;
  @Input() title: string;
  @Input() tfnoCta1: string;
  @Input() tfnoCta2: string;
  @Input() mailCta: string;
  @Input() iconoClase = 'icon-24 icon-ibm-phone';
  @Input() icono: string;
  @Input() label = 'Te llamamos';
  @Input() tituloDialog = 'Te llamamos';
  @Input() descripcionDialog: string;
  @Input() tituloDialogPrivacidad = 'Condiciones de uso';
  // TODO: Añadir LEGAL_EMAIL dinámico cuando se implemente alternativa a DC_CUSTOM
  @Input() descripcionDialogPrivacidad = 'Al pulsar el botón “Enviar”, autoriza el tratamiento de sus datos y su incorporación a un Fichero con la finalidad de atender su consulta. Puede ejercer los derechos de acceso, rectificación y cancelación y oposición, dirigiéndose por escrito, adjuntando fotocopia de su D.N.I., a Duacode SL Rúa Mendaña de Neyra, 26 bajo - 15008 A Coruña. Asimismo, le informamos que sus datos podrán ser utilizados por la empresa para remitirle información de su interés por cualquiera de los medios de contacto facilitados incluyendo los telemáticos. Si no desea recibir comunicaciones comerciales debe marcar la casilla habilitada en el formulario a tal efecto.';

  @ViewChildren(MainAccionesDialogoCtaComponent) accionesDialogoCta: QueryList<MainAccionesDialogoCtaComponent>;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  clickLink() {
    this.url ? window.location.href = this.url : this.dialog.open(this.accionesDialogoCta.first.dialogCta, {disableClose: true, width: '540px', minWidth: '300px',  panelClass: ['dialogoMainCta']});
  }
}
